export function getURL(path) {
  if (!window.location.origin) {
    window.location.origin = `https://${window.location.hostname}`;
  }
  return window.location.origin + path;
}
